import React, { useEffect, useState } from "react";
import "./dashboard.css";
import companyicon from "../../Asserts/Images/total_company.png";
import certificationicon from '../../Asserts/Images/certified_icon.png'
import auditimg from '../../Asserts/Images/audit_img.png'
import { FaArrowTrendUp } from "react-icons/fa6";
import { FaArrowTrendDown } from "react-icons/fa6";
import Instance from "../../AxiosConfig";
import { message } from "antd";

const DashboardCards = () => {


 const [totalCompanies,setTotalCompanies]=useState();
 const [totalCertification,setTotalCertifications]=useState();
 const [activeCertifications,setActiveCertifications]=useState();
 const [expiredCertifications,setExpiredCertifications]=useState();
 const [firstSurvellianceDue,setFirstSurvellianceDue]=useState();
 const [secondSurvellianceDue,setSecondSurvellianceDue]=useState();

 const handleDashboardCardsData = async () => {
  const token = localStorage.getItem("token");
  console.log("Token: ", token); // check if token exists

  try {
    const response = await Instance.get("overview/dashboard",
    //    {
    //   headers: { Authorization: `Bearer ${token}` }
    // }
  );

    console.log("API Response: ", response);  

    if (response.status === 200 || response.status === 201) {
      console.log("API Data: ", response.data);

      setTotalCompanies(response.data.totalCompanies);
      setTotalCertifications(response.data.totalCertifications);
      setActiveCertifications(response.data.activeCertifications);
      setExpiredCertifications(response.data.expiredCertifications);
      setFirstSurvellianceDue(response.data.firstSurveillanceDue);
      setSecondSurvellianceDue(response.data.secondSurveillanceDue);
    } else {
      console.log("Unexpected status code: ", response.status);
    }
  } catch (error) {
    console.error("API error: ", error);
    message.error("Failed to fetch dashboard data");
  }
};


 useEffect(()=>{
  handleDashboardCardsData();
 },[]);

  return (
    <div className="card-main">
      <div className="dashboard-cards">
        <div className="dashboard-card">
          <div className="d-flex justify-content-between align-items-center">
            <div className="card-content">
              <h5>Total Companies</h5>
              <h2>{totalCompanies?.count ?? 'Loading...'}</h2>

            </div>
            <div className="card-icon-one-bg">
              <img className="card-icon" src={companyicon} alt="" />
            </div>
          </div>
          <h6  className="card-h6"><span style={{color:'#00B69B'}}><FaArrowTrendUp style={{fontSize:'22px'}}/> {totalCompanies?.change ?? '0%'}</span>  {totalCompanies?.direction ?? ''}</h6>
        </div>

        <div className="dashboard-card">
          <div className="d-flex justify-content-between align-items-center">
            <div className="card-content">
              <h5>Total Certifications</h5>
              <h2>{totalCertification?.count ?? 'Loading...'}</h2>
            </div>
            <div className="card-icon-one-bg certification-icon">
              <img className="card-icon " src={certificationicon} alt="" />
            </div>
          </div>
          <h6 className="card-h6"><span style={{color:'#00B69B'}}><FaArrowTrendUp style={{fontSize:'22px'}}/> {totalCertification?.change ?? '0%'}</span> {totalCertification?.direction ?? ''}</h6>
        </div>

       <div className="dashboard-card">
          <div className="d-flex justify-content-between align-items-center">
            <div className="card-content">
              <h5>Active Certifications</h5>
              <h2>{activeCertifications?.count ?? 'Loading...'}</h2>
            </div>
            <div className="card-icon-one-bg certification-icon">
              <img className="card-icon" src={certificationicon} alt="" />
            </div>
          </div>
          <h6  className="card-h6"><span style={{color:'#00B69B'}}><FaArrowTrendUp style={{fontSize:'22px'}}/> {activeCertifications?.change ?? '0%'}</span> {activeCertifications?.direction ?? ''}</h6>
        </div>

         <div className="dashboard-card">
          <div className="d-flex justify-content-between align-items-center">
            <div className="card-content">
              <h5>Expired Certifications</h5>
              <h2>{expiredCertifications?.count ?? 'Loading...'}</h2>
            </div>
            <div className="card-icon-one-bg certification-icon">
              <img className="card-icon" src={certificationicon} alt="" />
            </div>
          </div>
          <h6 className="card-h6"><span style={{color:'#00B69B'}}><FaArrowTrendDown style={{fontSize:'22px',color:'red'}}/> {expiredCertifications?.change ?? '0%'}</span> {expiredCertifications?.direction ?? ''}</h6>
        </div>

        <div className="dashboard-card">
          <div className="d-flex justify-content-between align-items-center">
            <div className="card-content">
              <h5>1st Surveillance Audits Due</h5>
              <h2>{firstSurvellianceDue?.count ?? 'Loading...'}</h2>
            </div>
            <div className="card-icon-one-bg surveliance-icon-bg">
              <img className="card-icon" src={auditimg} alt="" />
            </div>
          </div>
          <h6  className="card-h6"><span style={{color:'#00B69B'}}><FaArrowTrendUp style={{fontSize:'22px'}}/> {firstSurvellianceDue?.change ?? '0%'}</span> {firstSurvellianceDue?.direction ?? ''}</h6>
        </div>

       <div className="dashboard-card">
          <div className="d-flex justify-content-between align-items-center">
            <div className="card-content">
              <h5>2nd Surveillance Audits Due</h5>
              <h2>{secondSurvellianceDue?.count ?? 'Loading...'}</h2>
            </div>
            <div className="card-icon-one-bg surveliance-icon-bg">
              <img className="card-icon" src={auditimg} alt="" />
            </div>
          </div>
          <h6  className="card-h6"><span style={{color:'#00B69B'}}><FaArrowTrendDown style={{fontSize:'22px',color:'red'}}/>  {secondSurvellianceDue?.change ?? '0%'}</span> {secondSurvellianceDue?.direction ?? ''}</h6>
        </div>

      </div>
    </div>
  );
};

export default DashboardCards;
